<div class="table-cell-container">
  @if (!isEditing) {
    <div
        [ngClass]="{
            'isHighlighted': isHighlighted,
            'notHighlighted': !isHighlighted,
            'changed': isChanged,
            'footnote': footnotes !== null,
            'insufficientValue': cell.validationFlag === 'INSUFFICIENT',
            'sufficientValue': cell.validationFlag === 'SUFFICIENT',
            'excludedFromCalculations': excludedFromCalculations
        }"
      (click)="startHighlightMode($event)"
      (dblclick)="startEditMode($event)"
      class="value-container"
      data-bs-toggle="tooltip"
      data-bs-placement="top"
      [title]="excludedFromCalculations ? excludedCellTooltipText : ''"
      >
      <app-comment-present-indicator
        [sourceComments]="sourceComments"
      ></app-comment-present-indicator>
      @if (newValue === 0 && isConsideredHeader(row)) {
        <span></span>
      }
      @if (newValue === 0 && !isConsideredHeader(row)) {
        <span>-</span>
      }
      @if (newValue !== 0) {
        <span>
          @if (showFormattedValue) {
            <span>{{formattedValue}}</span>
          }
          @if (!showFormattedValue) {
            <span>{{adjustedValueToDisplay() | formatDataFrameValue}}</span>
          }
        </span>
      }
      <div [ngClass]="{'show-on-hover': !contextMenuOpen}" class="cell-menu-toggle" (click)="toggleContextMenu($event)">
        <i class="fas fa-chevron-down"></i>
      </div>
      @if (insightsIsLoading) {
        <div class="cell-loading-spinner-container">
          <i class="fas fa-circle-notch fa-spin cell-loading-spinner"></i>
        </div>
      }
      @if (contextMenuOpen) {
        <ul class="dropdown-menu">
          @if (!isSourceStatement) {
            <li><span (click)="insightsClicked($event)"><i class="fas fa-chart-simple"></i>View Insights</span></li>
          }
          @if (allowEdit && isChanged) {
            <li><span (click)="revertToOriginal($event)">Revert to Original Value</span></li>
          }
          @if (footnotes !== null) {
            @for (footnote of footnotes; track footnote; let idx = $index) {
              <li>
                <span (click)="enterFootnotesMode(idx, $event)"><i class="fas fa-pen-to-square"></i>Show Footnote {{idx + 1}}</span>
              </li>
            }
          }
          @if (cellHasComments(cell)) {
            <li>
              <span (click)="openComments($event)"><i class="fas fa-comment"></i>Show Comment</span>
            </li>
          }
          <!-- only show document list to edit/download docs if the user is not in view only mode -->
          @if (!viewOnlyMode && showSpreadingInContextMenu && !allowEdit) {
            @for (doc of contextMenuDocumentItems; track doc) {
              <li class="dropdown-divider"></li>
              @if (!doc.isVendorData) {
                <li><span class="source-doc-section-header"><strong>{{doc.label}}</strong></span></li>
              }
              <li  class="context-menu-doc-action"><span (click)="contextMenuDocumentClicked(doc, $event, 'spread')"><i class="fas fa-pencil"></i>Edit Spread</span></li>
              @if (!doc.isVendorData) {
                <li class="context-menu-doc-action"><span (click)="contextMenuDocumentClicked(doc, $event, 'download')"><i class="fas fa-download"></i>Download Document</span></li>
              }
            }
          }
        </ul>
      }
    </div>
  }

  @if (isEditing) {
    <input
      type="text"
      #editCellTextbox
      [(ngModel)]="newValue"
      (focusout)="editComplete()"
      (keyup.enter)="editComplete()"
      (click)="stopPropagation($event)"
      />
  }

</div>
